<script>
export let currentRoute;


import { onMount } from 'svelte';


import Loading from 'components/elements/Loading.svelte';
import MsgCard from 'components/elements/MsgCard.svelte';


import Form from 'components/forms/views/form/team-instance-jersey-sponsor-order/Form.svelte';



import SvelteSeo from 'svelte-seo';



let successfully_submitted = false;



const forms_api_url = app_.env.FORMS_API_URL;






// async function getSeasonInstance() {

// 	const url = `${forms_api_url}/_data/season-instances/${currentRoute.namedParams.season_instance_id}`;

// 	const resp = await fetch(url, {
// 		method: 'GET',	
// 	});

// 	const result = await resp.json();

// 	if (!resp.ok) {
// 		throw new Error(result.detail);
// 	}

// 	return result;

// }



// let promise = getSeasonInstance();


</script>


<style>
	


</style>



<SvelteSeo
	title='Jersey Sponsor Form | AHG Forms'
	description='Jersey Sponsor Form!'
/>




<!-- {#await promise}

<Loading />

{:then season_instance} -->

<section class="hero bg-grey">

	<div class="hero-body">

		<div class="container">

			<p class="hero-subtitle has-text-centered">
				Jersey Sponsor Form<!-- : {season_instance.seasons_sc.name}
				{#if season_instance.year_start === season_instance.year_end}
				(season_instance.year_start)
				{:else}
				(season_instance.year_start - season_instance.year_end)
				{/if} -->
			</p>

		</div>

	</div>
	
</section>


<section class="section skinny-section">

	<div class="container">

		{#if successfully_submitted}

		<MsgCard msg_show={true} msg_text={"Successfully submitted! You can now leave this page."} msg_type={'error'} msg_forever={true} />

		{:else}

		<!-- contact mike or patrick... -->
		<MsgCard msg_show={true} msg_text={"Thank you for participating in the AHG Sponsorship Program. Please follow the directions in this form and fill out the required information. Please note that the deadline for sponsorships is March 10th. Please note that if you are registering multiple players, we would ask that you fill out a separate form.<br><br>Minimum $300 per sponsor: Maximum amount returned to participant: $275.00 ($300.00 - $25.00 administration fee). *Refunds for sponsorship funds in excess of registration fees are subject to HST.<br><br>If you have any sponsorship inquiries, please contact the office directly.<br><br>Merci de participer au programme de parrainage AHG. Veuillez suivre les instructions de ce formulaire et remplir les informations requises. Veuillez noter que la date limite pour les commandites est le 10 mars. Veuillez noter que si vous inscrivez plusieurs joueurs, nous vous demandons de remplir un formulaire séparé.<br><br>Recommander 300 $ par commanditaire : Montant maximum retourné au participant: 275,00 $ (300,00 $ - 25,00 $ de frais d'administration). * Les remboursements de fonds de commandite en sus des frais d'inscription sont assujettis à la TVH.<br><br>Si vous avez des questions, veuillez contacter directement notre bureau."} msg_type={'error'} msg_forever={true} />

		<MsgCard msg_show={true} msg_text={"Thank you for your support this spring hockey season!<br>If you have any sponsorship inquiries, please contact the office directly."} msg_type={'error'} msg_forever={true} />


		<MsgCard msg_show={true} msg_text={"Mailing address for cheques:<br>Atlantic Hockey Group<br>PO Box 1481<br>Moncton, NB<br>E1C 8T6"} msg_type={'error'} msg_forever={true} />



		<!-- ... -->

		<div class="card form-card" style="margin-bottom: 6rem !important;">

			<div class="card-content">

				<Form bind:successfully_submitted />

			</div>

		</div>

		{/if}

	</div>

</section>




<!-- {:catch error}

<section class="section skinny-section">

	<div class="container is-fullwidth">

		<MsgCard msg_show={true} msg_text={error.detail} msg_type={'error'} msg_forever={true} />

	</div>

</section>

{/await} -->





<!-- email: donotreply@atlantichockeygroup.com -->




